import messaging from '@react-native-firebase/messaging';
import auth from '@react-native-firebase/auth';
import * as Device from 'expo-device';

import {navigationRef} from 'src/Nav/navigationHelpers';

import {Alert, Platform} from 'react-native';
import {
  LoginManager,
  AccessToken,
  GraphRequest,
  GraphRequestManager,
} from 'src/Modules/Native/Facebook';
import {v4 as uuidv4} from 'uuid';

import {GoogleSignin} from 'src/Utils/googleAuth';
import {getDatabase} from 'src/Utils/db';

import {analytics} from 'src/Utils/db';

const google_ios_client_id =
  '472107255951-72uu587vuquodhkuhdoocnob81cmj4ju.apps.googleusercontent.com';

import {logForCrashlytics} from 'src/Utils/fireUtils';

import appleAuth from './appleAuth';
import {getAuth} from './db';
import {mmkvStorage} from './mmkvStorage';
import {apiTrackUserLogin} from './apiCalls';
import {
  createShareLink,
  createPassportShareLink,
  logCustomAnalyticsEvent,
} from './fireUtils';
import {dispatchAction, getReduxState, randomPhotoColor} from './helpers';
import {saveUserInfo} from '../Redux/reducers/user_info.reducer';

export const configureGoogleSignIn = () => {
  // logForCrashlytics('configureGoogleSignIn fired in loginFunctions')
  try {
    GoogleSignin.configure({
      webClientId:
        '472107255951-0tdfl6pp1tc67mlgkcvrt5dt3cjtatqq.apps.googleusercontent.com',
    });
    console.log('google sign in configured');
  } catch (err) {
    console.log('Sign in failed', err.message);
  }
};

export const tryGoogleLogin = async () => {
  logForCrashlytics('tryGoogleLogin fired in loginFunctions');

  if (Platform.OS == 'web') {
    console.log('trying web logging');
    try {
      const auth = getAuth();
      var provider = new auth.GoogleAuthProvider();
      const userInfo = await auth().signInWithPopup(provider);
      console.log('userInfo', {userInfo});
      if (Platform.OS == 'web' && !userInfo?.user?.email?.includes('@lets')) {
        return alert(
          `You can only sign in with your Let's Roam email for web demos. Please refresh your screen!`,
        );
      }
      return userInfo;
    } catch (err) {
      console.log('web login failed', {err});
      console.log(
        'upload sha1 keystore to https://console.firebase.google.com/u/0/project/barhuntv2/settings/general/android:com.barhuntv2',
      );
      console.log(
        'https://console.firebase.google.com/u/0/project/barhuntv2/settings/general/android:com.barhuntv2',
      );
      console.log(
        'keytool -list -v -keystore ~/.android/debug.keystore -alias androiddebugkey -storepass android -keypass android',
      );
      console.log(
        'keytool -list -v -keystore ~/.android/debug.keystore -alias androiddebugkey -storepass android -keypass android',
      );
      throw new Error(err);
    }
  } else {
    try {
      console.log('native google signin');
      await GoogleSignin.hasPlayServices();
      const userInfo = await GoogleSignin.signIn();
      console.log('google info', {userInfo});
      return userInfo;
    } catch (GoogleSigninError) {
      console.log(
        'upload sha1 keystore to https://console.firebase.google.com/u/0/project/barhuntv2/settings/general/android:com.barhuntv2',
      );
      console.log(
        'https://console.firebase.google.com/u/0/project/barhuntv2/settings/general/android:com.barhuntv2',
      );
      console.log(
        'keytool -list -v -keystore ~/.android/debug.keystore -alias androiddebugkey -storepass android -keypass android',
      );
      console.error('google sign in error', {GoogleSigninError});
      throw new Error(GoogleSigninError);
    }
  }
};

export const tryGoogleLogout = () => {
  logForCrashlytics('tryGoogleLogout fired in loginFunctions');
  return GoogleSignin.hasPlayServices({autoResolve: true})
    .then(() => {
      return GoogleSignin.configure({
        forceConsentPrompt: true,
        hostedDomain: '',
        iosClientId: google_ios_client_id,
      });
    })
    .then(() => {
      return (
        (GoogleSignin.currentUserAsync && GoogleSignin.currentUserAsync()) ||
        GoogleSignin
      );
    })
    .then(async () => {
      try {
        await GoogleSignin.signOut();
        await getAuth().signOut();
      } catch (err) {
        console.log(err);
      }
      return;
    });
};

const genUUID = () => {
  return uuidv4();
};

export const tryAppleLogin = async () => {
  logForCrashlytics('tryAppleLogin fired in loginFunctions');
  try {
    await GoogleSignin.signOut();
    await getAuth().signOut();
  } catch (err) {
    console.log(err);
  }

  console.log('try apple login');
  try {
    const appleAuthRequestResponse = await appleAuth.signInAsync({
      requestedScopes: [
        appleAuth.AppleAuthenticationScope.FULL_NAME,
        appleAuth.AppleAuthenticationScope.EMAIL,
      ],
    });

    // Ensure Apple returned a user identityToken
    if (!appleAuthRequestResponse.identityToken) {
      throw 'Apple Sign-In failed - no identify token returned';
    }

    console.log_on_production({appleAuthRequestResponse});

    // Create a Firebase credential from the response
    const {identityToken, nonce} = appleAuthRequestResponse;
    const appleCredential = auth.AppleAuthProvider.credential(
      identityToken,
      nonce,
    );

    console.log({identityToken, nonce, appleCredential});

    const email = `${genUUID()}`.substr(0, 10).toLowerCase?.() + '@gmail.com';
    return {
      email,
      contactEmail: email,
      contactPhone: '+1234567890',
      birthday: '2019-01-01',
      home_zip_code: '10000',
    };

    // Sign the user in with the credential
    return getAuth().signInWithCredential(appleCredential);
  } catch (err) {
    console.log('an error occured');
    console.log(err);
  }
};

export const tryFacebookLogin = () => {
  logForCrashlytics('tryFacebookLogin fired in loginFunctions');

  console.log('try facebbok login');
  try {
    return LoginManager.logInWithPermissions(['public_profile', 'email']).then(
      (result) => {
        console.log('the result is', result);
        if (result.isCancelled) {
          throw result;
        } else {
          AccessToken.getCurrentAccessToken()
            .then((data) => {
              const credential = auth?.FacebookAuthProvider?.credential?.(
                data?.accessToken,
              );
              console.log('the facebook token created is: ', credential);
            })
            .catch((error) => {
              Alert.alert('the access token was not created because:' + error);
            });
        }

        return new Promise((resolve, reject) => {
          const infoRequest = new GraphRequest(
            '/me',
            {
              parameters: {
                fields: {
                  string:
                    'email,name,first_name,middle_name,last_name,picture.type(large),gender',
                },
              },
            },
            (error, result) => {
              if (error) {
                console.log('Error fetching data: ' + error.toString());
                reject(error);
              } else {
                resolve(result);
              }
            },
          );

          new GraphRequestManager().addRequest(infoRequest).start();
        });
      },
    );
  } catch (err) {
    console.log('an error occured');
    console.log(err);
  }
};

export const tryFacebookLogout = () => {
  logForCrashlytics('tryFacebookLogout fired in loginFunctions');
  try {
    return LoginManager.logOut();
  } catch (err) {
    console.log(err);
  }
};

export const tryFirebaseLogout = () => {
  logForCrashlytics('tryFirebaseLogout fired in loginFunctions');
  try {
    getAuth().currentUser && auth().signOut();
  } catch (err) {
    console.log(err);
  }
};

export const handleFirebaseAuthChanged = (user, handleAuthChange) => {
  logForCrashlytics('handleFirebaseAuthChanged fired in loginFunctions');
  return getAuth().onAuthStateChanged((firebaseUser) => {
    console.log('auth state change', {firebaseUser});
    let formattedUser = {...firebaseUser};
    if (formattedUser?._user) {
      formattedUser.providerData = formattedUser?._user?.providerData;
    }
    console.log({providerData: formattedUser?.providerData});
    if (formattedUser?.providerData?.[0]) {
      if (!user?.info) {
        handleAuthChange(formattedUser);
      }
    }
  });
};

export const removeFirebaseAuthListener = (authListener) => {
  logForCrashlytics('removeFirebaseAuthListener fired in loginFunctions');
  try {
    authListener();
  } catch (err) {
    console.log(err);
  }
};

export const firebaseFindUser = async (email) => {
  logForCrashlytics('firebaseFindUser fired in loginFunctions');
  try {
    const response = await getDatabase()
      .ref()
      .child('users')
      .orderByChild('email')
      .equalTo(email)
      .once('value');
    if (response.val()) {
      return Object.values(response.val())[0];
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
  }
};

export const firebaseFindUserByContactEmail = async (contactEmail) => {
  logForCrashlytics('firebaseFindUserByContactEmail fired in loginFunctions');
  console.log({contactEmail});
  try {
    const response = await getDatabase()
      .ref()
      .child('users')
      .orderByChild('contactEmail')
      .equalTo(contactEmail)
      .once('value');
    console.log({response});
    if (response.val()) {
      console.log('matching user found!!');
      return Object.values(response.val())[0];
    } else {
      console.log('no matching users found');
      return false;
    }
  } catch (err) {
    console.log(err);
  }
};

export const firebaseLoginAnonymously = async (handleDone) => {
  navigationRef.navigate('ConfirmModal', {
    titleText: `Do you want to sign in anonymously to your event?`,
    titleBodyText: 'What is your first name or a nick name for your event',
    confirmText: 'Sign In',
    showPrompt: true,
    cancelText: 'Cancel',
    handleConfirm: async (newName, handleClose) => {
      if (!newName) {
        return Alert.alert('Please create a nick name');
      }
      try {
        const {user} = await auth().signInAnonymously();
        // eslint-disable-next-line no-use-before-define
        await loginAndCreateUser({
          email: `anonymous-${user.uid}`,
          contactEmail: `anonymous-${user.uid}`,
          firstName: newName,
        });
        console.log('User signed in anonymously');
        handleClose();
        handleDone();
      } catch (error) {
        if (error.code === 'auth/operation-not-allowed') {
          console.log('Enable anonymous in your firebase console.');
        }

        console.error(error);
      }
    },
  });
};

export const firebaseFindUserByContactPhone = async (contactPhone) => {
  logForCrashlytics('firebaseFindUserByContactPhone fired in loginFunctions');
  try {
    const response = await getDatabase()
      .ref()
      .child('users')
      .orderByChild('contactPhone')
      .equalTo(contactPhone)
      .once('value');
    if (response.val()) {
      console.log('matching user found!!');
      return Object.values(response.val())[0];
    } else {
      console.log('no matching users found');
      return false;
    }
  } catch (err) {
    console.log(err);
  }
};

export const firebaseSetUserFCMToken = async (userId = 'error', fcmToken) => {
  logForCrashlytics('firebaseSetUserFCMToken fired in loginFunctions');
  try {
    getDatabase().ref('users').child(userId).child('fcmToken').set(fcmToken);
  } catch (err) {
    console.log(err);
  }
};

export const firebaseLoginWithPhone = (phoneNumber = '') => {
  logForCrashlytics('firebaseLoginWithPhone fired in loginFunctions', {
    phoneNumber,
  });
  console.log('phone number');
  if (phoneNumber) {
    try {
      // turning off recaptcha for testing on simulator
      if (!Device.isDevice) {
        if (phoneNumber?.includes('4088089625'))
          console.log_on_production('turning off testing');
        getAuth().settings.appVerificationDisabledForTesting = true;
      }
      return getAuth().signInWithPhoneNumber(phoneNumber || '');
    } catch (err) {
      console.log_on_production('firebase error');
      console.warn(err);
    }
  }
  return false;
};

export const firebaseSubscribeMessaging = (topicId) => {
  logForCrashlytics('firebaseSubscribeMessaging fired in loginFunctions');
  try {
    console.log('firebaseSubscribeMessaging', {topicId});
    if (topicId) {
      messaging()
        .subscribeToTopic(topicId)
        .then((data) =>
          console.log('we registered in with data ', {data, topicId}),
        )
        .catch((err) => console.log('we could not register', err.message));
    }
  } catch (err) {
    console.log(err);
  }
};

export const firebaseSetUserInfo = (userId, userInfo) => {
  logForCrashlytics('firebaseSetUserInfo fired in loginFunctions');
  try {
    getDatabase().ref('users').child(userId).set(userInfo);
  } catch (err) {
    console.log(err);
  }
};

const setLoginItems = async (userId, userInfo) => {
  const region = getReduxState(['location', 'region']) || {};
  const {latitude = 0, longitude = 0} = region;
  mmkvStorage.set('userId', userId);
  mmkvStorage.set('userInfo', JSON.stringify(userInfo));
  try {
    analytics().logLogin();
    analytics().setUserId(userId);
    apiTrackUserLogin({user_id: userId, latitude, longitude});
  } catch (error) {
    console.log({error});
  }
  try {
    userInfo && !userInfo?.shareLink && createShareLink(userId);
    userInfo &&
      !userInfo?.passportShareLinkV2 &&
      createPassportShareLink(userId);
  } catch (error) {
    // Alert.alert('error', JSON.stringify(error));
  }
  dispatchAction(saveUserInfo(userInfo));

  // CHECK BOTH NAV ACTIONS
};

export const loginAndCreateUser = async (params = {}) => {
  const {
    email = '',
    contactEmail = '',
    contactPhone = '',
    firstName = '',
    lastName = '',
    googleId = '',
    photoUrl = '',
    birthday = null,
    home_zip_code = null,
    contactPhoneNonLogin = null,
  } = params;
  console.log('loginAndCreateUser', {params});
  const playTestState = getReduxState(['app_info', 'playTestState']);
  const letsRoamUser = !!contactPhone
    ? await firebaseFindUserByContactPhone(contactPhone)
    : await firebaseFindUserByContactEmail(contactEmail);
  console.log({contactPhone, contactEmail, letsRoamUser});
  let fcmToken = await mmkvStorage.getString('fcmToken');
  if (letsRoamUser) {
    const {userId} = letsRoamUser;
    if (!fcmToken || (letsRoamUser && fcmToken != letsRoamUser.fcmToken)) {
      firebaseSetUserFCMToken(userId, fcmToken);
    }
    userId && !playTestState && firebaseSubscribeMessaging(userId);
    /// this should be helper as well

    logCustomAnalyticsEvent('user_relogin', {
      userId: userId,
      ...params,
    });
    setLoginItems(userId, letsRoamUser);

    return letsRoamUser;

    // creating a new user
  } else {
    const userId = `${genUUID()}`.substr(0, 6).toLowerCase?.();
    userId && !playTestState && firebaseSubscribeMessaging(userId);
    // console.log('The user id is ', userId)
    const userInfo = {
      userId,
      prepaidJoinCode: `${userId}`.toLowerCase?.(),
      email,
      contactEmail,
      contactPhone: contactPhone || contactPhoneNonLogin || null,
      firstName: firstName || 'User',
      lastName: lastName || 'User',
      googleId: googleId || '',
      photoUrl: photoUrl || null,
      socialPhotoUrl: photoUrl || null,
      birthday,
      home_zip_code,
      photoColor: randomPhotoColor(),
      coins: 0,

      tickets: {
        Bachelor: 0,
        Bachelorette: 0,
        Birthday: 0,
        'Date Night': 0,
        Standard: 0,
      },
      level: 1,
      loggedIn: true,
      source: 'lr_app',
    };

    logCustomAnalyticsEvent('user_first_login', {
      userId: userId,
      ...params,
    });

    const referral = await mmkvStorage.getString('referral');
    const passportReferral = await mmkvStorage.getString('passportReferral');

    if (referral) {
      userInfo.referral = JSON.parse(referral);
      userInfo.coins = 300;
    }
    if (passportReferral) {
      userInfo.passportReferral = JSON.parse(passportReferral);
    }
    if (fcmToken) {
      userInfo.fcmToken = fcmToken;
    }
    firebaseSetUserInfo(userId, userInfo);
    setLoginItems(userId, userInfo);

    return userInfo;
  }
};
